import request from "@/utils/request";

export default function agentChangeDevice(params) {
  return request({
    url: `/device/agent/chargingPile/changeDevice`,
    method: "post",
    params,
  });
}
